import ConfigurableBackground from './_configurable-background.js'
import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import AbsolutePane from './_absolute-pane.js'
import Animation from './_animation.js'
import Spinner from './_spinner.js'

export default {
  name: 'AnimatedButton',
  values: {
    isSpinner: false,
    style: {
      animatedBackground: {
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
    },
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
            borderRadius: '4px',
            alignItems: 'center',
            overflow: 'hidden',
          },
        },
      },
    },
    confirm: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
            borderRadius: '4px',
            alignItems: 'center',
          },
        },
      },
    },
    success: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
            borderRadius: '4px',
            alignItems: 'center',
          },
        },
      },
    },
    fail: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
            borderRadius: '4px',
            alignItems: 'center',
          },
        },
      },
    },
    childrenContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 0,
        },
      },
    },
    animatedBackgroundContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
    animation: {
      configSet: Animation,
      configValues: {
        animationDuration: '5s',
        animationIterationCount: 'infinite',
        keyframes: {
          from: {
            width: '0%',
          },
          to: {
            width: '100%',
          },
        },
      },
    },
    spinnerWithContentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'center',
          alignItems: 'center',
        },
        itemSpacing: '4px',
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
